import { PayrollRunParticipantsDocument } from 'generated/resources/graphql'

import { MentionedAccess } from 'modules/core/components/TextEditor/plugins/DebouncedMentionsPlugin'
import { useLazyQuery } from 'modules/core/hooks/useQuery'

interface UsePayrollRunParticipantsOptions {
  participantAccessIds: number[]
  isBookkeeperView?: boolean
}

export const usePayrollRunParticipants = ({
  participantAccessIds,
  isBookkeeperView = false,
}: UsePayrollRunParticipantsOptions) => {
  const [fetchParticipants] = useLazyQuery(PayrollRunParticipantsDocument)

  const fetchMentionableAccesses = async (queryString: string): Promise<MentionedAccess[]> => {
    if (!participantAccessIds || participantAccessIds.length === 0) {
      return []
    }

    const result = await fetchParticipants({
      variables: {
        ids: participantAccessIds,
        search: queryString || undefined,
      },
      ...(isBookkeeperView && { context: { isBookkeeperView: true } }),
    })

    return (
      result.data?.apiCore.accessesConnection.nodes.map((access) => ({
        id: access.id,
        fullName: access.fullName,
        avatar: access.avatar ?? '',
      })) ?? []
    )
  }

  return { fetchMentionableAccesses }
}
